import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vfmPlugin from 'vue-final-modal'
import Toast from "vue-toastification";

import './registerServiceWorker'

import "vue-toastification/dist/index.css";
import authStore from "./store/auth-store";

import axiosInstance from './services/axios-service';
const app = createApp(App);

app.use(router);
app.use(Toast, { position: "bottom-right" });
app.use(VueAxios, axiosInstance);
app.use(vfmPlugin);
app.use(authStore);

authStore.commit("initialiseStore");

app.mixin({
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  }
});

app.mount("#app");

// import authStore from "./store/auth-store";
// console.log(authStore);

//createApp(App).use(router).mount('#app')
